import React, { Fragment } from 'react'
import { Disclosure } from '@headlessui/react'
import classNames from 'classnames'
import { twMerge } from 'tailwind-merge'
import Icon from '../Icon'

export const Accordion = ({
  title = '',
  children = null,
  className = '',
  panelClassName = '',
  ...props
}) => {

  const buttonClasses = [
    'rounded',
    'text-xl',
    'p-7',
    'w-full',
    'bg-light',
    'border',
    'flex',
    'justify-between',
    'items-center',
  ]
  
  const panelClasses = [
    'p-7',
  ]

  return <div>
    <Disclosure>
    {({ open }) => (
      <Fragment>
        <Disclosure.Button className={classNames(twMerge(buttonClasses, className))}>
          <span>{title}</span>
          <Icon icon={open ? ['fas', 'minus'] : ['fas', 'plus']} className="text-primary" />
        </Disclosure.Button>
        <Disclosure.Panel className={classNames(twMerge(panelClasses, panelClassName))}>
          {children}
        </Disclosure.Panel>
      </Fragment>
    )}
    </Disclosure>
  </div>
}

export default Accordion
